export class URLQueryStringParser {
    /**
     * JavaScript Get URL Parameter
     *
     * @prop String prop The specific URL parameter you want to retreive the value for
     * @return String|Object If prop is provided a string value is returned, otherwise null is returned
     */
    getUrlParams(prop) {
        let params = {};
        let search = decodeURIComponent(window.location.href.slice(window.location.href.indexOf('?') + 1));
        let definitions = search.split('&');

        definitions.forEach(function (val, key) {
            let parts = val.split('=', 2);
            params[parts[0]] = parts[1];
        });

        return ( prop && prop in params ) ? params[prop] : null;
    }
}